export const getTempUrl = (id: string | number) => {
  return `listed-items/images/temp/${id}/medium.jpg`
}

export const getUrl = (id: string | number) => {
  return `listed-items/images/${id}/medium.jpg`
}
